// public/js/features/tracker-config/api.js
export async function loadTemplates() {
  const res = await window.authenticatedFetch('api/v1/config-templates');
  if (!res.ok) throw new Error(`templates ${res.status}`);
  return res.json();   // { settings, platform, tenant }
}
export async function createTemplate(payload) {
  const res = await window.authenticatedFetch('api/v1/config-templates', {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error || 'Failed to create template');
  return (await res.json()).template;
}
export async function updateTemplate(id, payload) {
  const res = await window.authenticatedFetch(`api/v1/config-templates/${encodeURIComponent(id)}`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error || 'Failed to update template');
  return (await res.json()).template;
}
export async function deleteTemplate(id) {
  const res = await window.authenticatedFetch(`api/v1/config-templates/${encodeURIComponent(id)}`, { method: 'DELETE' });
  if (!res.ok) throw new Error('Failed to delete template');
  return res.json();
}

// Asset config (assignment + per-device twin)
export async function loadAssetConfig(assetUUID) {
  const res = await window.authenticatedFetch(`api/v1/assets/${encodeURIComponent(assetUUID)}/config`);
  if (!res.ok) throw new Error(`asset config ${res.status}`);
  return res.json();   // { assetTemplateId, devices:[{deviceId,model,overrideTemplateId,desired,sourceTemplateId,twin}] }
}
export async function assignAssetTemplate(assetUUID, templateId) {
  const res = await window.authenticatedFetch(`api/v1/assets/${encodeURIComponent(assetUUID)}/config`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ templateId }),
  });
  if (!res.ok) throw new Error('Failed to assign template');
  return res.json();
}
export async function setDeviceOverride(deviceId, templateId) {
  const res = await window.authenticatedFetch(`api/v1/devices/${encodeURIComponent(deviceId)}/config`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ templateId }),
  });
  if (!res.ok) throw new Error('Failed to set device override');
  return res.json();
}
export async function simulateCheckin(deviceId) {
  const res = await window.authenticatedFetch(`api/v1/devices/${encodeURIComponent(deviceId)}/config/checkin`, { method: 'POST' });
  if (!res.ok) throw new Error('Failed to simulate check-in');
  return res.json();
}
